export default {
  zh: {
    ra: "充值账户",
    r: "充值",
    eu: "请输入充值的用户ID",
    noExit: "该ID不存在",
    noNull: "不能为空",
    search: "查询",
    enterNation: "请选择国家",
    hot: "热门",
    all: "所有",
    policy: "阅读并同意App的服务条款、退货政策和隐私政策",
    otherId: "更换其他ID",
    eId: "请先选择需要充值的ID",
    help: "帮助",
    
    eNation: "请选择国家",
    ePayMethods: "请选择支付方式",
    eRechargeGold: "请选择充值金额",
    ePolicy: "请选择同意条款",
    successful:"The operation was successful",
  },
  
  en: {
    ra: "Recharge Account",
    r: "Recharge",
    eu: "Please Enter User ID",
    noExit: "This ID dosen’t exist.",
    noNull: "Cannot be empty",
    search: "Verify",
    enterNation: "Please select a country",
    hot: "Hot",
    all: "All",
    policy: "Read and agree to App's Terms of Service, Return Policy and Privacy Policy",
    otherId: "Recharge other ID",
    eId: "Please select the ID that needs to be recharged first",
    help: "Help",
    ruby: "Ruby",
    eNation: "Please select a country",
    ePayMethods: "Please select mode of payment",
    eRechargeGold: "Please enter the recharge amount",
    ePolicy: "Please agree to the terms",
    gold: "Gold",
    successful:"The operation was successful",
  },

  ar: {
    ra: "حساب الشحن",
    r: "الشحن",
    eu: "أدخل ايدي",
    noExit: "هذا الايدي ليس موجودا",
    noNull: "لا يمكن أن تكون فارغة",
    search: "التحقيق",
    enterNation: "اختر دولة",
    hot: "شائع",
    all: "جميع",
    policy: "اقرأ ووافق على شروط الخدمة سياسة الإرجاع وسياسة الخاصة بشاتي الخصوصية",
    otherId: "تغيير الايدي",
    eId: "الرجاء إدخال معرف المستخدم",
    help: "ساعد",
    gold: "ذهب",
    eNation: "رجاء قم بإختيار دوله",
    ePayMethods: "الرجاء تحديد طريقة الدفع",
    eRechargeGold: "الرجاء إدخال مبلغ إعادة الشحن",
    ePolicy: "الرجاء الموافقة على الشروط",
    ruby: "ياقوت",
    successful:"العملية كانت ناجحه",
  },

  tr: {
    ra: "şarj hesabı",
    r: "şarj etmek",
    eu: "Lütfen şarj kullanıcı kimliğini girin",
    noExit: "Kimlik mevcut değil",
    noNull: "Boş olamaz",
    search: "Sorgula",
    enterNation: "Lütfen bir ülke seçin",
    hot: "popüler",
    all: "Tümü",
    policy: "App'nin Hizmet Şartları, İade Politikası ve Gizlilik Politikasını okuyun ve kabul edin",
    otherId: "Başka bir kimliği değiştir",
    eId: "Lütfen önce şarj edilmesi gereken kimliği seçin",
    help: "yardım",
    ruby: "Yakut",
    eNation: "Lütfen bir ülke seçin",
    ePayMethods: "Lütfen ödeme şeklini seçin",
    eRechargeGold: "Lütfen şarj miktarını seçin",
    ePolicy: "Lütfen şartları kabul etmeyi seçin",
    gold: "Altın paralar",
    successful:"İşlem Başarılı Oldu",
  },

  jp: {
    ra: "リチャージアカウント",
    r: "再充電",
    eu: "リチャージユーザーIDを入力してください",
    noExit: "IDが存在しません",
    noNull: "空にすることはできません",
    search: "お問い合わせ",
    enterNation: "国を選択してください",
    hot: "人気",
    all: "全て",
    policy: "App の利用規約、返品ポリシー、プライバシー ポリシーを読み、同意する",
    otherId: "別の ID を変更する",
    eId: "最初にリチャージする必要がある ID を選択してください",
    help: "ヘルプ",

    eNation: "国を選択してください",
    ePayMethods: "お支払い方法を選択してください",
    eRechargeGold: "チャージ金額を選択してください",
    ePolicy: "利用規約への同意を選択してください",
    gold: "Gold",
    successful:"The operation was successful",
  },
  pt:{
    ra: "Conta de recarga",
    r: "Recarga",
    eu: "Por favor, insira o ID do usuário",
    noExit: "Este ID não existe.",
    noNull: "Não pode estar vazio",
    search: "Verificar",
    enterNation: "Por favor, selecione um país",
    hot: "Popular",
    all: "Todos",
    policy: "Leia e concorde com os Termos de Serviço, Política de Devolução e Política de Privacidade do App",
    otherId: "Recargar outro ID",
    eId: "Por favor, selecione o ID que precisa ser recarregado primeiro",
    help: "Ajuda",
    ruby: "Rubi",
    eNation: "Por favor, selecione um país",
    ePayMethods: "Por favor, selecione o método de pagamento",
    eRechargeGold: "Por favor, insira o valor da recarga",
    ePolicy: "Por favor, concorde com os termos",
    gold: "Ouro",
    successful: "A operação foi bem-sucedida",

  },
  id:{
    ra: "Akun Pengisian",
    r: "Pengisian",
    eu: "Silakan masukkan ID Pengguna",
    noExit: "ID ini tidak ada.",
    noNull: "Tidak boleh kosong",
    search: "Verifikasi",
    enterNation: "Silakan pilih negara",
    hot: "Panas",
    all: "Semua",
    policy: "Baca dan setujui Ketentuan Layanan App, Kebijakan Pengembalian, dan Kebijakan Privasi",
    otherId: "Isi ulang ID lain",
    eId: "Silakan pilih ID yang perlu diisi ulang terlebih dahulu",
    help: "Bantuan",
    ruby: "Ruby",
    eNation: "Silakan pilih negara",
    ePayMethods: "Silakan pilih metode pembayaran",
    eRechargeGold: "Silakan masukkan jumlah pengisian",
    ePolicy: "Silakan setujui syarat-syarat",
    gold: "Emas",
    successful: "Operasi berhasil",

  },
  "uz": {
        "ra": "Hisobni toʻldirish",
        "r": "Toʻldirish",
        "eu": "Iltimos, foydalanuvchi ID sini kiriting",
        "noExit": "Bu ID mavjud emas.",
        "noNull": "Bo‘sh bo‘lishi mumkin emas",
        "search": "Tekshirish",
        "enterNation": "Iltimos, mamlakatni tanlang",
        "hot": "Ommabop",
        "all": "Barchasi",
        "policy": "Ilovaning Xizmat ko‘rsatish shartlari, Qaytarish siyosati va Maxfiylik siyosatini o‘qing va rozilik bildiring",
        "otherId": "Boshqa ID ga toʻldirish",
        "eId": "Iltimos, avval toʻldirilishi kerak bo‘lgan ID ni tanlang",
        "help": "Yordam",
        "ruby": "Rubi",
        "eNation": "Iltimos, mamlakatni tanlang",
        "ePayMethods": "Iltimos, toʻlov usulini tanlang",
        "eRechargeGold": "Iltimos, toʻldirish miqdorini kiriting",
        "ePolicy": "Iltimos, shartlarga rozilik bildiring",
        "gold": "Tilla",
        "successful": "Amaliyot muvaffaqiyatli bajarildi"
    },
    "ru": {
        "ra": "Пополнить счет",
        "r": "Пополнить",
        "eu": "Пожалуйста, введите ID пользователя",
        "noExit": "Этот ID не существует.",
        "noNull": "Не может быть пустым",
        "search": "Проверить",
        "enterNation": "Пожалуйста, выберите страну",
        "hot": "Популярное",
        "all": "Все",
        "policy": "Прочитайте и согласитесь с Условиями обслуживания, Политикой возврата и Политикой конфиденциальности приложения",
        "otherId": "Пополнить другой ID",
        "eId": "Пожалуйста, сначала выберите ID для пополнения",
        "help": "Помощь",
        "ruby": "Рубин",
        "eNation": "Пожалуйста, выберите страну",
        "ePayMethods": "Пожалуйста, выберите способ оплаты",
        "eRechargeGold": "Пожалуйста, введите сумму пополнения",
        "ePolicy": "Пожалуйста, согласитесь с условиями",
        "gold": "Золото",
        "successful": "Операция выполнена успешно"
    },
    "fa": {
        "ra": "شارژ حساب",
        "r": "شارژ",
        "eu": "لطفاً شناسه کاربری را وارد کنید",
        "noExit": "این شناسه وجود ندارد.",
        "noNull": "نمی‌تواند خالی باشد",
        "search": "تأیید",
        "enterNation": "لطفاً کشور را انتخاب کنید",
        "hot": "داغ",
        "all": "همه",
        "policy": "شرایط خدمات، سیاست بازگشت و سیاست حفظ حریم خصوصی برنامه را بخوانید و بپذیرید",
        "otherId": "شارژ شناسه دیگر",
        "eId": "لطفاً ابتدا شناسه‌ای که باید شارژ شود را انتخاب کنید",
        "help": "راهنما",
        "ruby": "یاقوت",
        "eNation": "لطفاً کشور را انتخاب کنید",
        "ePayMethods": "لطفاً روش پرداخت را انتخاب کنید",
        "eRechargeGold": "لطفاً مقدار شارژ را وارد کنید",
        "ePolicy": "لطفاً شرایط را بپذیرید",
        "gold": "طلا",
        "successful": "عملیات با موفقیت انجام شد"
    }
}


// WEBPACK FOOTER //
// src/pages/app/recharge/lang.js